export const PHONE_PATTERN = /^\+[1-9]\d{0,3}\d{9,15}$/;
export const PASSWORD_PATTERN = /(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
